import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { getFullPath } from '../lib/get-full-path';
import { RedirectService } from '../services/redirect.service';
import { StateService } from '../services/state.service';
import { StorageService } from '../services/storage.service';
import { ViewGalleryGuard } from '../view-gallery/guards/view-gallery.guard';

@Injectable({
  providedIn: 'root',
})
export class GalleryAccessGuard {
  private platformId = inject<string>(PLATFORM_ID);
  private viewGalleryGuard = inject(ViewGalleryGuard);
  private redirectService = inject(RedirectService);
  private state = inject(StateService);
  private storage = inject(StorageService);

  async canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    if (isPlatformServer(this.platformId)) {
      return true;
    }

    if (next.queryParams.preview === 'true') {
      this.state.galleryPreviewMode = true;
      this.storage.remove('galleryPasswords');
    }

    const fullPath = getFullPath(next);
    const resp = await this.viewGalleryGuard.getGalleryPathAction(next);

    if (resp === true) {
      return this.redirectService.redirectTo(
        fullPath.filter(u => !['access', 'error', 'not-found'].includes(u)),
        { queryParams: next.queryParams }
      );
    }

    if (resp === 'access') return true;

    if (resp === 'offline') return true;

    return this.viewGalleryGuard.redirectToAction(next, resp);
  }
}
